import { __assign, __rest } from "tslib";
import React from 'react';
import isEqual from 'lodash/isEqual';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { useDropdownItems } from '../../hooks/useDropdownItems';
import StandardDropdownMenu from '../StandardDropdown/StandardDropdownMenu';
import { PopperDropdownManager, } from '../../PopperDropdownLayout';
import PopperIconToggleButton from '../../toggles/PopperIconToggleButton';
/**
 * Our DS `IconButton` with a context menu provided by our dropdown library.
 *
 * You can customize the popper or standarded menu instance via `popperManagerProps` or `standardMenuProps` respectively.
 */
var IconButtonWithContextMenu = React.memo(function (_a) {
    var items = _a.items, openOnHover = _a.openOnHover, popperManagerProps = _a.popperManagerProps, standardMenuProps = _a.standardMenuProps, placement = _a.placement, rest = __rest(_a, ["items", "openOnHover", "popperManagerProps", "standardMenuProps", "placement"]);
    var filteredItems = useDropdownItems(items).filteredItems;
    var toggleId = useUniqueId();
    var dropdownId = useUniqueId();
    return (React.createElement(PopperDropdownManager, __assign({}, popperManagerProps, { openOnHover: openOnHover }),
        React.createElement(PopperIconToggleButton, __assign({ id: toggleId, "aria-haspopup": "menu", "aria-controls": dropdownId }, rest)),
        React.createElement(StandardDropdownMenu, __assign({ id: dropdownId, role: "menu", "aria-labelledby": toggleId, menuScrollable: true, items: filteredItems, placement: placement, offsetModifier: openOnHover
                ? [
                    0, 0,
                ] /* no gap - to not hide the menu when mouse travels from the toggle to the menu */
                : undefined }, standardMenuProps))));
}, 
// Deep equal from lodash so we can compare the standard menu and popper manager prop collections
isEqual);
IconButtonWithContextMenu.displayName = 'IconButtonWithContextMenu';
export default IconButtonWithContextMenu;
//# sourceMappingURL=IconButtonWithContextMenu.js.map